<template>
    <div class="coupon-goods-page">
        <NavBar title="优惠商品" >
            <template #stickyBox>
                 <van-tabs v-model="type" @click="handleTab"  v-if="goodsList.length">
                    <van-tab v-for="(item,index) in goodsList" :key="index" :name="item.name" :title="item.title" />
                </van-tabs> 
            </template>
        </NavBar>
        <!-- 实物 -->
        <div v-if="type == 0">
            <div class="block-item">
                <EntityGoodsList :list="dataList" @handleClick="handleClick" />
            </div>
            <div class="block-item" v-if="recommendDataList.length">
                <div class="block-title">推荐商品</div>
                <EntityGoodsList :list="recommendDataList" @handleClick="handleClick" />
            </div>
        </div>
         <!-- 培训 -->
        <div v-if="type == 1">
            <div class="block-item">
                <div class="goods-list">
                    <GoodsItem v-for="item in dataList" :key="item.id" :data="item" />
                </div>
            </div>
            <div class="block-item" v-if="recommendDataList.length">
                <div class="block-title">推荐商品</div>
                <div class="goods-list">
                    <GoodsItem v-for="item in recommendDataList" :key="item.id" :data="item" />
                </div>
            </div>
        </div>
        <!-- 分销 -->
        <div v-if="type == 2">
            <div class="block-item">
                <div class="goods-list">
                    <GoodsItem v-for="item in dataList" :key="item.id" :data="item" />
                </div>
            </div>
        </div>
        <div class="no-data" v-if="loaded && !recommendDataList.length && !dataList.length">
            <empty description="暂无可用优惠商品" />
        </div>
    </div>
</template>

<script>
import NavBar from '../../../components/NavBar/index.vue';
import EntityGoodsList from '../../../components/EntityGoods/list';
import GoodsItem from '../components/goodsItem.vue';
export default {
    components: {
        NavBar,
        GoodsItem,
        EntityGoodsList,
    },
    data() {
        return {
            isInit: true,
            loaded: false,
            ucode: this.$route.query.ucode,
            type: this.$route.query.type,
            allData: [],
            goodsList: [],
            recommendDataList: [],
            dataList: []
        }
    },
    created () {
        this.dataList = []
        this.recommendDataList = []
        this.getData(this.type, true);
    },
    methods: {
        onSetGoodList(obj) {
            let list = []
            for(let key in obj) {
                list.push({
                    title: key == '3'? '实物商品': key == '2' ? '分销商品' : '培训商品',
                    name: key == '3'? '0':  key == '2' ? '2' :'1'
                })
            }
            list.sort((a,b)=>{
                return a.name > b.name ? 1:-1
            })
            this.goodsList = list;
            
        },
        getData(type, init = false) {
            this.dataList = [];
            this.recommendDataList = [];
            this.$api.coupon.couponGoodsList({
                ucode: this.ucode
            }).then(({success, data})=>{
                this.loaded = true;
                if(success) { 
                    this.allData = data;
                    // 0 实物 1 培训 2 分销
                    let index = type || (Array.isArray(data.youhui[3]) && data.youhui[3].length ? 0 :1);
                    if (data.youhui[3] == undefined && data.youhui[1] == undefined && data.youhui[2].length) {
                      index = 2
                    }
                    this.type = index;
                    this.getCurrentData(index, data)
                    // 设置tab
                    if(Object.keys(data.youhui).length > 1) {
                        this.onSetGoodList(data.youhui)
                    }
                }
            })
        },
        getCurrentData(index, data) {  
            const typeList = {
                0: 'shiwu',
                1: 'peixun',
            }
            const goodsTyleList = {
                0: '3',
                1: '1',
                2: '2'
            }
            const currentType = typeList[index];
            this.dataList = data.youhui[goodsTyleList[index]];
            this.recommendDataList = data[currentType] || [];
        },
        handleTab(index) {
            this.$router.replace(`/couponGoodsList?ucode=${this.ucode}&type=${index}`)
            this.loaded = false;
            this.getCurrentData(String(index), this.allData)
        },
        handleClick({goodsId, id}) {
            this.$router.push({
                path: '/entityGoodsDetail',
                query: {
                    goodsId: goodsId || id,
                    goodsKinds: 3,
                    visit_referrer: 'couponGoodsList',
                    isH5: 1,
                    autoplay: 0,
                }
            })
        }
    },
}
</script>
<style lang="less" scoped>
    ::v-deep {
        .van-tabs {
            padding: 24/37.5rem 0;
            background-color: #fff;
            margin-bottom: 24/37.5rem;
        }
        .van-tabs__wrap {
            height: 34/37.5rem;
            
            .van-tabs__nav {
                background-color: transparent;
                justify-content: flex-start;
                padding-left: 32/37.5rem;
            }
            .van-tab {
                font-size: 32/37.5rem;
                line-height: 40/37.5rem;
                color: #999;
                position: relative;
                z-index: 2;
                padding: 0;
                flex: 1 0 auto;
                margin-right: 32/37.5rem;
                &:last-of-type {
                    margin: 0;
                }
                &.van-tab--active {
                    color: #333;
                }
            }
            .van-tabs__nav--line {
                padding-bottom: 0;
            }
            .van-tabs__line {
                background-color: #025EFE;
                width: 62/37.5rem;
                height: 8/37.5rem;
                bottom: 0;
                border-radius: 0;
            }
        }
    }
    .coupon-goods-page {
        min-height: 100vh;
        background-color: #F8FAFC;
        padding-bottom: 110px;
        .block-item {
            margin-top: 20px;
            padding: 0 24px;
            .block-title {
                color: #333;
                font-size: 32px;
                line-height: 40px;
                padding: 0;
                font-weight: 500;
                margin-bottom: 20px;
            }
            .goods-list {
                ::v-deep {
                    .goods-item {
                        margin-bottom: 20px;
                    }
                }
            }
        }
    }
</style>